import { slicedToArray as _slicedToArray } from '../../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState, useEffect } from 'react';
import share from '../../images/share-ios.svg.js';
import mailShare from '../../images/share-mail.svg.js';
import { SocialShare as SocialShare$2 } from './SocialShare.styles.js';

var SocialShare = function SocialShare() {
  var _document2, _window2;
  var handleShare = function handleShare(event) {
    event.preventDefault();
    if (navigator.share) {
      var _document, _window;
      navigator.share({
        title: (_document = document) === null || _document === void 0 ? void 0 : _document.title,
        text: 'Check out this post:',
        url: (_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.href
      }).then(function () {
        return console.log('Successful share');
      })["catch"](function (error) {
        return console.log('Error sharing:', error);
      }); // eslint-disable-line
    } else {
      // Fallback code for browsers that do not support navigator.share
      console.log('Sharing is not supported in this browser.'); // eslint-disable-line
    }
  };
  var mailtoLink = "mailto:?subject=".concat(encodeURIComponent((_document2 = document) === null || _document2 === void 0 ? void 0 : _document2.title), "&body=").concat(encodeURIComponent("I thought you might find this interesting:\n".concat((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.location.href)));
  return /*#__PURE__*/React__default.createElement(SocialShare$2, null, /*#__PURE__*/React__default.createElement("button", {
    onClick: function onClick(event) {
      return handleShare(event);
    },
    className: "share",
    type: "button"
  }, /*#__PURE__*/React__default.createElement("img", {
    src: share,
    alt: "Share this page"
  })), /*#__PURE__*/React__default.createElement("a", {
    className: "mail",
    href: mailtoLink
  }, /*#__PURE__*/React__default.createElement("img", {
    src: mailShare,
    alt: "Share via Email"
  })), ' ');
};
var SocialShareWrapper = function SocialShareWrapper(props) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    mounted = _useState2[0],
    setMounted = _useState2[1];
  useEffect(function () {
    setMounted(true);
  }, [setMounted]);
  return mounted && /*#__PURE__*/React__default.createElement(SocialShare, props);
};
var SocialShare$1 = SocialShareWrapper;

export { SocialShare$1 as default };
//# sourceMappingURL=index.js.map
